import React, { useEffect, useState } from "react";
import ColorHash from "color-hash";
import AnonUser from "@/assets/legacy-images/anon-user.svg?react";
import { motion } from "motion/react";
import { MDSUserAvatarProps } from "./user-avatar.types";
import { StyledAvatarContainer, StyledAvatarImage, StyledAnonIcon } from "./user-avatar.style";
import { ThemeType, useTheme } from "@/mds/themes";

const MotionAvatarImage = motion(StyledAvatarImage);

export const MDSUserAvatar = ({ photoUrl, displayName, size = 24 }: MDSUserAvatarProps) => {
  const { themeType } = useTheme();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    setIsImageLoaded(false);
  }, [photoUrl]);

  if (photoUrl) {
    return (
      <StyledAvatarContainer $size={size}>
        <MotionAvatarImage
          src={photoUrl}
          alt={displayName}
          onLoad={() => setIsImageLoaded(true)}
          initial={{ opacity: 0 }}
          animate={{ opacity: isImageLoaded ? 1 : 0 }}
          transition={{ duration: 0.16, ease: "easeOut" }}
        />
      </StyledAvatarContainer>
    );
  }

  if (!displayName) {
    return (
      <StyledAvatarContainer $size={size}>
        <StyledAnonIcon as={AnonUser} />
      </StyledAvatarContainer>
    );
  }

  const lightBgColorHash = new ColorHash({ lightness: 0.91, saturation: 0.92 });
  const darkBgColorHash = new ColorHash({ lightness: 0.2, saturation: 0.59 });
  const colorHash = themeType === ThemeType.Harvest ? lightBgColorHash : darkBgColorHash;
  const backgroundColor = colorHash.hex(displayName);
  const displayNameInitial = displayName[0].toUpperCase();

  return (
    <StyledAvatarContainer $size={size} style={{ backgroundColor }}>
      {displayNameInitial}
    </StyledAvatarContainer>
  );
};
